// extracted by mini-css-extract-plugin
export default {"editApp":"ENWj97wfjg6wdR95HUeZ"};